import { render, staticRenderFns } from "./DialogChange.vue?vue&type=template&id=bc7339ec&scoped=true"
import script from "./DialogChange.vue?vue&type=script&lang=js"
export * from "./DialogChange.vue?vue&type=script&lang=js"
import style0 from "./DialogChange.vue?vue&type=style&index=0&id=bc7339ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7339ec",
  null
  
)

export default component.exports